export default {
  title: 'Signez votre devis',
  card: {
    content: 'Signez votre contrat de déménagement électroniquement pour finaliser votre réservation.',
    contentIndividual: 'Félicitations, votre paiement a été enregistré. Dernière étape : signer votre contrat de déménagement.',
  },
  button: {
    sign: 'Signer',
  },
  book: {
    title: 'Signez votre devis',
    titleIndividual: 'Confirmation de votre réservation (1/2)',
    subtitle: 'Signature de votre contrat de déménagement',
    infoStep: {
      content: '<b>ÉTAPE {currentStep}/{totalSteps}</b><br>La dernière étape de la réservation de votre déménagement.<br/><b>Ne partez pas sans avoir signé votre contrat !</b>',
    },
    content: '<b>Un contrat de déménagement encadre la prestation délivrée par le professionnel.</b><br/>Nous vous invitons à vérifier les informations présentes dans le document puis à signer.<br/>La signature est réalisée via le prestataire de signature électronique Yousign® qui vous demandera un code reçu par SMS.',
    memo: '<b>Il n’est pas nécessaire de remplir la déclaration de valeur à ce stade, vous en aurez l’occasion après la signature du contrat.</b><br/>La déclaration de valeur doit comporter la liste et la valeur de chaque meuble que vous estimez comme supérieure au montant de l’indemnisation forfaitaire par meuble qui figure au contrat. Vous pouvez nous la transmettre jusqu\'à 10 jours avant votre déménagement via la section &laquo; Démarches &raquo;, mais pour l’heure pas d’urgence.',
  },
};
